<div [ngClass]="{'darkMode': darkModeService.darkMode}">

    <mat-form-field>
      <mat-label>{{ ("GLOBAL_USERS_ADMIN.FILTER_NAME"  | translate) }}</mat-label>
      <input matInput (keyup)="applyFilter($event)">
    </mat-form-field>

    <table mat-table [dataSource]="dataSource" matSort>
        <caption style="display:none;">Global Administrators</caption>
        <ng-container matColumnDef="name">
            <th scope="col" mat-header-cell *matHeaderCellDef> {{ ("GLOBAL_USERS_ADMIN.COL_NAME"  | translate) }} </th>
            <td mat-cell *matCellDef="let nuuma"> {{nuuma.name}} </td>
        </ng-container>

        <ng-container matColumnDef="mail">
          <th scope="col" mat-header-cell *matHeaderCellDef> mail </th>
          <td mat-cell *matCellDef="let nuuma"> {{nuuma.mail}} </td>
      </ng-container>

        <ng-container matColumnDef="action">
            <th scope="col" mat-header-cell *matHeaderCellDef> {{ ("GLOBAL_USERS_ADMIN.COL_ACTION"  | translate) }} </th>
            <td mat-cell *matCellDef="let nuuma">
                <button
                    mat-button
                    matSuffix
                    mat-icon-button
                    (click)= "remove(nuuma)"
                    aria-label="Clear">
                    <mat-icon>delete</mat-icon>
                </button>
            </td>
        </ng-container>

        <ng-container matColumnDef="addUser" >
          <td mat-footer-cell *matFooterCellDef>
            <input 
              class= "input"
              placeholder="{{ 'GLOBAL_USERS_ADMIN.NUUMAS' | translate }}"
              matInput
              #adminInput
              pattern="[a-zA-Z0-9-_.@]*"
              [formControl]="adminCtrl"
              [matAutocomplete]="autoNuumas"
              >    
            <mat-error *ngIf="!adminCtrl.pristine && adminCtrl.errors">
              {{ ("GLOBAL_USERS_ADMIN.INVALID_CHARACTERS"  | translate) }}
            </mat-error>          
            <mat-autocomplete #autoNuumas="matAutocomplete" (optionSelected)="selected($event)">
              <mat-option disabled class="loading" *ngIf="(loading)  && (!adminCtrl.errors)">
                  <mat-spinner diameter="35"></mat-spinner>
              </mat-option>
              <mat-optgroup label="{{ 'GLOBAL_USERS_ADMIN.NUUMAS' | translate }}" *ngIf="(filteredNuumas)  && (!adminCtrl.errors)">
                <mat-option *ngFor="let nuuma of filteredNuumas | async" [value]=" nuuma" >
                  {{ nuuma }}
                </mat-option>
              </mat-optgroup>
              <mat-option disabled *ngIf="notResults  && (!adminCtrl.errors)">
                Not results
              </mat-option>
            </mat-autocomplete>
      
          </td>
        </ng-container>

        <ng-container matColumnDef="updateTable">
          <td mat-footer-cell *matFooterCellDef colspan="2">
            <button
              *ngIf="false"
              mat-button
              matSuffix
              mat-icon-button
              [disabled]="!isSelect"
              (click)= "addNew(newRole)"
              >
              <mat-icon>add</mat-icon>
            </button>
            </td>
          </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr mat-footer-row *matFooterRowDef="['addUser', 'updateTable']"></tr>
                
    </table>
    <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

    <div *ngIf="repUser" class="warning">{{ ("GLOBAL_USERS_ADMIN.ADMIN_REPEATED"  | translate) }}</div>
    <div *ngIf="atLeastOneAdmin" class="alert">{{ ("GLOBAL_USERS_ADMIN.ADMIN_NOT_EMPTY"  | translate) }}</div>
    <div *ngIf="adminUserEmpty" class="warning">{{ ("GLOBAL_USERS_ADMIN.EMPTY_ADMIN"  | translate) }}</div>
    <div *ngIf="userToDeleteSameAsLogged" class="warning">{{ ("GLOBAL_USERS_ADMIN.CANNOT_DELETE_YOURSELF"  | translate) }}</div>
    <div *ngIf="adminMustBeSelected" class="warning">{{ ("GLOBAL_USERS_ADMIN.ADMIN_MUST_BE_SELECTED"  | translate) }}</div>
  
</div>
